import React from 'react';

import { InformationLabel, InformationLine } from './styles';

interface LineProps {
	label: string;
	value: string;
}

export function Line({ label, value }: Readonly<LineProps>): JSX.Element {
	return (
		<InformationLine>
			<InformationLabel>{`${label}: `}</InformationLabel>
			{value}
		</InformationLine>
	);
}
